<template>
    <div>
    <label class="custom-checkbox" v-for="option in powerpackOptions" @click.prevent="handleSupportInput(option)">
        <span class="checkbox" :class="{checked: option.selected}">
            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="check" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-check fa-w-16 fa-5x"><path fill="currentColor" d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z" class=""></path></svg>
        </span>
        <span class="text" v-text="label"></span>
    </label>
    </div>
</template>

<script>
    import {mapGetters,mapMutations} from 'vuex';

  export default {
    name: "Checkbox",
    props: {
      label: {
        type: String,
        default: ''
      }
    },
    computed: {
      ...mapGetters({
        powerpackOptions: 'powerpackOptions/getAll'
      })
    },
    methods: {
      ...mapMutations({
        toggleOption: 'powerpackOptions/toggleSelected',
      }),
      handleSupportInput(option) {
        this.toggleOption(option);
        // console.log(e.target.checked)
        // const bool = e.target.checked === 'true'; //make sure always a bool
        // option.selected = bool;

        // this.powerpackStore({bool});
        // console.log(this.powerpackOptions)
      }
    }
  }
</script>

<style scoped lang="scss">
    .custom-checkbox {
        display: flex;
        align-items: center;
        width: 106px;
        height: 38px;
        user-select: none;
        cursor: pointer;

        .checkbox {
            display: block;
            width: 17px;
            height: 17px;
            border: 2px solid #707070;
            border-radius: 3px;
            padding: 1px;

            svg {
                display: block;
                opacity: 0;
                transition: all ease 0.3s;
            }

            &.checked {
                border-color: black;

                svg {
                    opacity: 1;
                }
            }
        }

        .text {
            font-size: 12px;
            height: 17px;
            margin-left: 5px;
        }

    }
</style>
